import CIMSBasicFields from 'components/CIMSBasicFields'
import { useProjectSettingsContext } from '../../../../../../ProjectSettingsContext'
import { HelpMessage } from 'utils/constants'
import { dateFormatter } from '../../../../../../../../../../../../../utils/dateFormatter'

const Help = HelpMessage.Administration.ProjectSettings.IFITracker

const PunchListViewPanel: React.VFC = () => {
  const {
    punchListIFISettings: { data },
  } = useProjectSettingsContext()

  return (
    <CIMSBasicFields
      fields={[
        {
          label: 'Effective Date',
          help: Help.EffectiveDate,
          children: dateFormatter.simple(data?.effectiveDate),
        },
      ]}
    />
  )
}

export default PunchListViewPanel
